import { connect, MapDispatchToProps } from "react-redux";
import EnrolmentGraph, { IEnrollmentGraphProps } from "pages/Report/Graphs";
import { enrolmentOptionListRequest } from "store/studentEnrolment/actions";
import { IGraph, IGraphContainerDispatch } from "utils/interfaces/graph-report";
import { termListRequest } from "store/term/actions";
import { getGraphDetailsRequest } from "store/report/actions";

const mapDispatchToProps: MapDispatchToProps<IGraphContainerDispatch, IGraph> =
  {
    enrolmentOptionListRequest,
    termListRequest,
    getGraphDetailsRequest,
  };

const connector = connect(null, mapDispatchToProps);

const Graphs: React.FC<IEnrollmentGraphProps> = (props) => {
  return <EnrolmentGraph {...props} />;
};

export default connector(Graphs);
